export const breakpoints = {
    base: 0,
    xs: 390,
    sm: 700,
    md: 834,
    lg: 1080,
    xl: 1440,
    '2xl': 1920,
};
export const breakpointKeys = Object.keys(breakpoints);
export const getBreakpoint = (width) => Object.keys(breakpoints).reduce((acc, key) => (width >= breakpoints[key] ? key : acc), 'base');
